import React, { useEffect, useState, useRef, useContext } from 'react';
import { Toast } from 'primereact/toast';
import Form from 'react-bootstrap/Form';
import './factorData.css'
import { BreadCrumb } from 'primereact/breadcrumb';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
// import TimePicker from "react-multi-date-picker/plugins/time_picker";
import { TimePicker } from 'react-ios-time-picker';

// import MapIcon from '../../assets/icons/map.svg';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import MapComponent from '../MapComponent';
import { getUserInfo, UpdateUserInfo, confirmFactor, getDeliverDate, changePass, getAddress, addAddress, getCity, getProvince } from '../../utils/api';
import moment from 'jalali-moment';
import Loadr from '../loader/loader';
import LoaderPage from '../loader/dotloader';
import { Accordion } from 'react-bootstrap'
import useToastNotification from '../../hooks/useToastNotification';

import { Dropdown } from 'primereact/dropdown';


//icon
import MapIcon from '../../assets/icons/address/map.svg'

function Profile() { // Receive onProfileLoad as a prop
    const toast = useRef(null);
    const [createDate, setCreateDate] = useState(null);
    const [visible, setVisible] = useState(false);
    const [loader, setLoader] = useState(false);
    const [loading, setLoading] = useState(false);
    const [validated, setValidated] = useState(false);
    const [brandNameCheck, setBrandNameCheck] = useState(false);
    const [provinces, setProvinces] = useState([]);
    const [addressList, setAddressList] = useState([]);
    const [cities, setCities] = useState([]);
    const [address, setAddress] = useState('');
    const [brandName, setBrandName] = useState('');
    const [addressId, setAddressId] = useState('');
    const [cityName, setCityName] = useState('');
    const [fullName, setFullName] = useState('');
    const [mobile, setMobile] = useState('');
    const [userName, setUserName] = useState('');
    const { showError, showSuccess } = useToastNotification();
    const [phone, setPhone] = useState('');
    const [lat, setLat] = useState('');
    const [lng, setLng] = useState('');
    const [description, setDescription] = useState('');




    //receiver
    const [receiverName, setReceiverName] = useState('');
    const [receiverMobile, setReceiverMobile] = useState('');
    const [receverPhone, setReceverPhone] = useState('');
    const [receiverAddress, setReceiverAddress] = useState('');
    const [deliveryDate, setDeliveryDate] = useState('');
    const [deliveryTime, setDeliveryTime] = useState(null);
    const [deliverDate, setDeliverDate] = useState(null);
    const [receiverPostalCode, setReceiverPostalCode] = useState('');
    const [receiverProvince, setReceiverProvince] = useState('');
    const [receiverCity, setReceiverCity] = useState('');

    const [mahiyat, setMahiyat] = useState({
        code: 3,
        name: 'نامشخص'
    });
    const [email, setEmail] = useState('');
    const [customerData, setCustomerData] = useState();
    const getCustomer = async (id) => {
        try {
            setLoading(true)
            let response = await getUserInfo(id);
            if (response.data != null) {

                setEmail(response.data.email)
                setMobile(response.data.phone)
                setFullName(response.data.fullname)
                setAddress(response.data.adres)
                setUserName(response.data.loginname)
                setMahiyat({
                    code: response.data.mahiyat,
                    name: response.data.mahiyat === 'B' ? 'حقیقی' : 'حقوقی'
                })

                setCreateDate(response.data.datestart)
                const provinceNameFromServer = response.data.Ostan;
                const cityNameFromServer = response.data.City;

                setTimeout(() => {
                    const matchedProvince = provinces.find(p => p.CName === provinceNameFromServer);
                    if (matchedProvince) {
                        setReceiverProvince(matchedProvince);
                        fetchCity(matchedProvince.Si).then(() => {
                            setTimeout(() => {
                                const matchedCity = cities.find(c => c.CName === cityNameFromServer);
                                if (matchedCity) {
                                    setReceiverCity(matchedCity);
                                }
                            }, 300); // زمان برای بارگذاری cities
                        });
                    }
                }, 800);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false)

        }
    }

    const fetchProvince = async () => {
        try {
            //   setLoading(true)
            let res = await getProvince()
            if (res.status == '200') {
                setLoading(false)
                setProvinces(res.data)
                return res.data
            }

        } catch (error) {

        } finally {
            setLoading(false)
        }
    }
    const fetchAddress = async (provincesData) => {
        try {
            //   setLoading(true)
            let res = await getAddress(JSON.parse(localStorage.getItem('userInfo')).si)
            if (res.status == '200') {
                setLoading(false)
                setAddressList(res.data)
                setTimeout(() => {
                    if (res.data.length > 0) {
                        // setAddressId(res.data[0].Si)

                        chooseAddress(res.data[0], provincesData)
                    }
                }, 1000);

            }
            let resp = await getDeliverDate()
            setDeliverDate(resp.data)
        } catch (error) {

        } finally {
            setLoading(false)
        }
    }
    const fetchCity = async (id) => {
        try {
            let res = await getCity(id)
            if (res.status == '200') {
                setCities(res.data)

            }

        } catch (error) {

        } finally {
        }
    }
    const fetchCityAddress = async (id) => {
        setCityAddress('')
        try {
            let res = await getCity(id)
            if (res.status == '200') {
                setCityAddressList(res.data)

            }

        } catch (error) {

        } finally {
        }
    }
    useEffect(() => {
        const initialize = async () => {
            const customerDatares = window.localStorage.getItem('userInfo');
            const parsedData = JSON.parse(customerDatares);
            setCustomerData(parsedData);
            getCustomer(parsedData.si);

            const provincesData = await fetchProvince();
            setProvince(provincesData)
            if (provincesData.length > 0) {
                await fetchAddress(provincesData); // فقط وقتی استان‌ها اومدن
            }
        };

        initialize();
    }, []);
    useEffect(() => {

    }, [provinces])
    const convertDateToPersian = (date) => {
        if (!date) return '-';
        return moment(date).locale("fa").format("YYYY/MM/DD");
    };
    // const convertDateToEn = (date) => {
    //     if (!date) return '-';
    //     return moment(date, 'jYYYY/jMM/jDD').format('YYYY/MM/DD');
    // };

    const mahiyatOption = [
        { name: 'حقیقی', code: 'B' },
        { name: 'حقوقی', code: 'C' }];
    const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"]

    const updateInfo = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (deliveryDate == null || deliveryDate == '') {
            showError('لطفا تاریخ تحویل را وارد کنید')
            return
        }
        if (deliveryTime == null || deliveryTime == '') {
            showError('لطفا ساعت تحویل را وارد کنید')
            return
        }
        if (form.checkValidity() === true) {
            event.stopPropagation();
            if (!addressId || addressId == '') {
                let res = await addAddressFunc(event)
            }
            try {
                setLoader(true);
                let pay = {
                    userId: (customerData.si).toString(),
                    adresId: (addressId?.Si)?.toString(),
                    nikeName: receiverName,
                    postal: receiverPostalCode,
                    phone: receiverMobile,
                    phone_Second: receverPhone,
                    address: receiverAddress,
                    cityId: (receiverCity?.Si)?.toString(),
                    ostanId: (receiverProvince?.Si)?.toString(),
                    newCity: cityName,
                    dateTahvil: deliveryDate,
                    timeTahvil: deliveryTime?.toString(),
                    tp: description
                }
                let response = await confirmFactor(pay);

                if (response.data.res == 'OK') {


                    showSuccess(response.data.restp);
                    setTimeout(() => {

                        window.location.href = '/order-list'
                        setLoader(false)
                    }, 5000);

                } else if (response.data.res === 'NotOk') {
                    setLoader(false);

                    let error = {
                        title: 'اخطار',
                        text: response.data.restp,
                    };
                    showError(error);
                }
            } catch (error) {
                setLoader(false);
                console.log(error);
                showError('خطا در برقراری ارتباط...');
            }
        }

        setValidated(true);
    }

    //address
    const [visibleAddress, setVisibleAddress] = useState(false)
    const [addressLoader, setAddressLoader] = useState(false)
    const [addAddressVisible, setAddAddressVisible] = useState(false)
    const [city, setCity] = useState('')
    const [province, setProvince] = useState('')
    const [addressFeild, setAddressFeild] = useState('')
    const [cityAddress, setCityAddress] = useState('')
    const [provinceAddress, setProvinceAddress] = useState('')
    const [addressFeildText, setAddressFeildText] = useState('')
    const [addressMobile, setAddressMobile] = useState('')
    const [cityAddressList,  setCityAddressList] = useState([])
    const [addressPhone, setAddressPhone] = useState('')
    const [nikNameAddress, setNiknameAddress] = useState('')
    const [postalCodeAddress, setPostalCodeAddress] = useState('')
    const [addAddressValidate, setAddAddressValidate] = useState(false)

    const handleDialogClose = () => {
        setVisibleAddress(false);
    };
    const handleAddDialogClose = () => {
        setAddAddressVisible(false);
    };
    const getCityById = (id) => {
        setProvinceAddress(id)
        fetchCityAddress(id.Si)
    };
    const getReceiverCityById = (id) => {
        setReceiverProvince(id)
        fetchCity(id.Si)
    };
    const handleAddressSelect = (selectedAddress, lat, lng) => {
        setLng(lng)
        setLat(lat)
        setAddressFeildText(selectedAddress);
    };
    const addAddressFunc = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (!receiverCity.Si || !receiverProvince.Si) {
            showError('لطفا استان و شهر را وارد کنید')
            return
        }
        if (form.checkValidity() === true) {
            event.stopPropagation();
            try {
                setAddressLoader(true);
                let pay = {
                    userId: (customerData.si).toString(),
                    phone: addressMobile,
                    phone_Second: addressPhone,
                    adresId: '0',
                    // phone: mobile,
                    postal: postalCodeAddress,
                    address: addressFeildText,
                    cityId: (cityAddress?.Si)?.toString(),
                    ostanId: (provinceAddress?.Si)?.toString(),
                    lat: lat ? parseInt(lat).toString() : '',
                    leng: lng ? parseInt(lng).toString() : '',
                    nikeName: nikNameAddress,
                }
                let response = await addAddress(pay);

                if (response.status == '200') {

                    setAddAddressVisible(false)
                    setAddressLoader(false)
                    showSuccess(response.data.res);
                    fetchAddress(provinces)

                } else {
                    // setAddressLoader(false);

                    let error = {
                        title: 'اخطار',
                        text: response.data.restp,
                    };
                    showError(error);
                }
            } catch (error) {
                setAddressLoader(false);
                console.log(error);
                showError('خطا در برقراری ارتباط...');
            }
        }

        setAddAddressValidate(true);
    }
    useEffect(() => {
    }, [cities])

    const onChange = (timeValue) => {
        setDeliveryTime(timeValue);
    }
    const chooseAddress = async (item, provincesData) => {
        setReceiverName(item.NikeName)
        setReceiverMobile(item.Phone)
        setReceverPhone(item.phone_Second)
        setReceiverProvince(item.Ostan)
        setReceiverCity(item.City)
        setReceiverPostalCode(item.Postal_Code)
        setReceiverAddress(item.Addres)
        setAddressId(item)

        const provinceNameFromServer = item.Ostan;
        const cityNameFromServer = item.City;
        const matchedProvince = provincesData.find(p => p.CName === provinceNameFromServer);
        if (matchedProvince) {
            setReceiverProvince(matchedProvince);
            try {
                let res = await getCity(matchedProvince.Si)
                if (res.status == '200') {
                    setCities(res.data)
                    const matchedCity = res.data.find(c => c.CName === cityNameFromServer);
                    if (matchedCity) {
                        setReceiverCity(matchedCity);
                    }
                }

            } catch (error) {

            } finally {
            }
        }
    }
    const [pickerOpen, setPickerOpen] = useState(false);

    const openTimePicker = () => {
        setTimeout(() => {

            const inputEl = document.querySelector('.react-ios-time-picker-input');
            const popup = document.querySelector('.react-ios-time-picker-popup');

            if (inputEl && popup) {
                const rect = inputEl.getBoundingClientRect();
                popup.style.position = 'absolute';
                popup.style.top = `${rect.bottom + window.scrollY + 4}px`;
                popup.style.left = `${rect.left + window.scrollX}px`;
                popup.style.right = 'auto';
                popup.style.bottom = 'auto';
                popup.style.zIndex = '9999';
            }
        }, 100);
    }
    const openDialogAddress = () => {
        setLat('')
        setLng('')
        setNiknameAddress('')
        setProvinceAddress('')
        setCityAddress('')
        setAddressFeildText('')
        setPostalCodeAddress('')
        setAddressMobile('')
        setAddressPhone('')
        setAddAddressVisible(true)
    }

    return (
        <>
            {loading && <LoaderPage isLoading={loading} />}
            <Form className='mb-4' noValidate validated={validated} onSubmit={(e) => updateInfo(e)}>

                <div >
                    {/* <h6 className='page-title my-4'>حساب کاربری</h6> */}
                    <div className='row gx-5 gy-2'>

                        <Form.Group className="col-md-6 col-lg-3 col-sm-12">
                            <Form.Label>نام و نام خانوادگی <span className='text-[red]'> * </span></Form.Label>
                            <Form.Control type="text" disabled required value={fullName} onChange={(e) => setFullName(e.target.value)} />
                            <Form.Control.Feedback type="invalid">
                                نام و نام خانوادگی را وارد کنید.
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="col-md-6 col-lg-3 col-sm-12">
                            <Form.Label>ماهیت <span className='text-[red]'> * </span></Form.Label>
                            <Dropdown value={mahiyat} disabled onChange={(e) => { setMahiyat(e.value); console.log(e.value) }} options={mahiyatOption} optionLabel="name"
                                className="w-100 " />

                        </Form.Group>
                        <Form.Group className="col-md-6 col-lg-3 col-sm-12">
                            <Form.Label>ایمیل <span className='text-[red]'> * </span></Form.Label>
                            <Form.Control type="text" required disabled value={email} onChange={(e) => setEmail(e.target.value)} />
                            <Form.Control.Feedback type="invalid">
                                ایمیل را وارد کنید.
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="col-md-6 col-lg-3 col-sm-12">
                            <Form.Label>شماره همراه <span className='text-[red]'> * </span></Form.Label>
                            <Form.Control type="number" required disabled value={mobile} onChange={(e) => setMobile(e.target.value)} />
                        </Form.Group>
                        {
                            mahiyat.code === 'C' && (
                                <Form.Group className="col-md-6 col-lg-3 col-sm-12">
                                    <Form.Label>تلفن <span className='text-[red]'> * </span></Form.Label>
                                    <Form.Control type="number" required disabled value={phone} onChange={(e) => setPhone(e.target.value)} />
                                </Form.Group>

                            )
                        }

                        <Form.Group className="col-md-6 col-lg-6 col-sm-12">
                            <Form.Label>توضیحات</Form.Label>
                            <div className='d-flex align-items-center gap-2'>
                                <Form.Control type="text" value={description} onChange={(e) => setDescription(e.target.value)} />
                            </div>
                        </Form.Group>
                    </div>


                </div>
                <div className='recever-card mt-3'>
                    <div className='p-3'>

                        <h6 className='page-title mb-4'>اطلاعات تحویل گیرنده</h6>
                        <Form.Group className="col-md-6 col-lg-3 col-sm-12">
                            <Form.Label>آدرس های قبلی شما</Form.Label>
                            <div className='d-flex gap-2'>
                                <Dropdown value={addressId} onChange={(e) => chooseAddress(e.value, provinces)} options={addressList} optionLabel="Addres"
                                    emptyMessage="هیچ آدرسی یافت نشد" className="w-100 " />
                                <button type='button' className='btn w-[40px] btn-address' style={{ backgroundColor: '#00a14b', height: '40px', fontSize: '20px', color: '#fff' }} onClick={() => openDialogAddress()}>
                                    +
                                </button>
                            </div>

                        </Form.Group>

                        <div className="row gy-2 gx-5 mt-2">
                            <Form.Group className="col-md-6 col-lg-3 col-sm-12">
                                <Form.Label>نام و نام خانوادگی <span className='text-[red]'> * </span></Form.Label>
                                <Form.Control type="text" disabled={addressId} required value={receiverName} onChange={(e) => setReceiverName(e.target.value)} />
                                <Form.Control.Feedback type="invalid">
                                    نام و نام خانوادگی را وارد کنید.
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group className="col-md-6 col-lg-3 col-sm-12">
                                <Form.Label>شماره همراه <span className='text-[red]'> * </span></Form.Label>
                                <Form.Control type="number" disabled={addressId} required value={receiverMobile} onChange={(e) => setReceiverMobile(e.target.value)} />
                            </Form.Group>
                            <Form.Group className="col-md-6 col-lg-3 col-sm-12">
                                <Form.Label>شماره همراه دوم <span className='text-[red]'> * </span></Form.Label>
                                <Form.Control type="number" disabled={addressId} required value={receverPhone} onChange={(e) => setReceverPhone(e.target.value)} />
                            </Form.Group>
                            <Form.Group className="col-md-6 col-lg-3 col-sm-12">
                                <Form.Label>کدپستی </Form.Label>
                                <Form.Control  disabled={addressId} type="number" value={receiverPostalCode} onChange={(e) => setReceiverPostalCode(e.target.value)} />
                            </Form.Group>
                        </div>

                        <div className='row gy-2 gx-5 mt-2'>
                            <Form.Group className="col-md-3 col-lg-3 col-sm-12">
                                <Form.Label>استان <span className='text-[red]'> * </span></Form.Label>
                                <Dropdown value={receiverProvince} disabled={addressId} onChange={(e) => getReceiverCityById(e.value)} options={provinces} optionLabel="CName"
                                    className="w-100 " />
                            </Form.Group>
                            <Form.Group className="col-md-3 col-lg-3 col-sm-12">
                                <Form.Label>شهر <span className='text-[red]'> * </span></Form.Label>
                                <Dropdown value={receiverCity} disabled={addressId} onChange={(e) => setReceiverCity(e.value)} options={cities} optionLabel="CName"
                                    className="w-100 " />
                            </Form.Group>
                            <Form.Group className="col-md-6 col-lg-6 col-sm-12">
                                <Form.Label>آدرس <span className='text-[red]'> * </span></Form.Label>
                                <div className=''>
                                    <Form.Control required type="text" disabled={addressId} value={receiverAddress} onChange={(e) => setReceiverAddress(e.target.value)} />

                                    <Form.Control.Feedback type="invalid">
                                        آدرس را وارد کنید.
                                    </Form.Control.Feedback>
                                </div>
                            </Form.Group>

                        </div>
                        <div className="row gy-2 gx-5 mt-2">

                            <Form.Group className="col-md-6 col-lg-3 col-sm-12">
                                <Form.Label>تاریخ تحویل <span className='text-[red]'> * </span></Form.Label>
                                <DatePicker
                                    weekDays={weekDays}
                                    value={deliveryDate}
                                    onChange={(date) => setDeliveryDate(convertDateToPersian(date.toDate()))}
                                    calendar={persian}
                                    locale={persian_fa}
                                    minDate={new Date().setDate(new Date().getDate() + (parseInt(deliverDate?.[0].MinDays)))} // تنظیم حداقل تاریخ بر اساس MinDays یا 3 روز

                                />
                            </Form.Group>

                            <Form.Group className="col-md-6 col-lg-3 col-sm-12 position-relative">
                                <Form.Label>ساعت تحویل <span className='text-[red]'> * </span></Form.Label>
                                <div>
                                    <TimePicker
                                        value={deliveryTime}
                                        onChange={onChange}
                                        onOpen={() => openTimePicker()}
                                        onClose={() => setPickerOpen(false)}
                                        placeHolder=""
                                        saveButtonText="ذخیره"
                                        cancelButtonText="انصراف"
                                    />
                                </div>


                                {/* 
    <DatePicker
        format="HH:mm"
        value={deliveryTime}
        onChange={setDeliveryTime}
        plugins={[<TimePicker hideSeconds />]}
        disableDayPicker
        calendar={persian}
        locale={persian_fa}
        weekDays={weekDays}
        editable={false} // کاربر فقط از طریق پیکر انتخاب می‌کنه
    /> */}
                            </Form.Group>

                        </div>

                    </div>

                </div>
                <div className='d-flex justify-content-end'>
                    <button disabled={loader} className='btn btn-primary mt-3'>ثبت  {loader && <Loadr />}</button>
                </div>
            </Form>
            {/* <div className='d-flex align-items-center gap-3 mt-3'>
                <Form.Check

                    className=" text-sm font-bold text-[#242526]"
                    label="ثبت با نام برند شما"
                    type="checkbox"
                    checked={brandNameCheck}
                    onChange={(e) => setBrandNameCheck(e.target.checked)}
                />
                {brandNameCheck && (
                    <div className='row flex-1'>
                        <Form.Group className="col-md-6 col-lg-3 col-sm-12">
                            <Form.Control placeholder='نام برند خود را وارد کنید...' type="text" required value={brandName} onChange={(e) => setBrandName(e.target.value)} />
                        </Form.Group>
                    </div>
                )}

            </div> */}

            <Dialog
                draggable={false}
                dismissableMask
                visible={addAddressVisible}
                style={{ width: '40vw' }}
                breakpoints={{ '600px': '400vw', '500px': '100vw' }}
                onHide={handleAddDialogClose}
                className="custom-dialog dialog-profile"
            >

                <Form className='row  mb-4 gy-3 px-2' noValidate validated={addAddressValidate} onSubmit={(e) => addAddressFunc(e)}>
                    <button type='button' className='btn btn-outline-primary d-flex align-items-center justify-content-center gap-2 w-100' onClick={() => setVisible(true)}> <img src={MapIcon} />انتخاب موقعیت مکانی</button>
                    <Form.Group className="col-md-6 col-lg-6 col-sm-12">
                        <Form.Label>نام و نام خانوادگی <span className='text-[red]'> * </span></Form.Label>
                        <Form.Control required type="text" value={nikNameAddress} onChange={(e) => setNiknameAddress(e.target.value)} />
                        <Form.Control.Feedback type="invalid">
                            نام و نام خانوادگی را وارد کنید.
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="col-md-6 col-lg-6 col-sm-12">
                        <Form.Label>موبایل <span className='text-[red]'> * </span></Form.Label>
                        <Form.Control required type="number" value={addressMobile} onChange={(e) => setAddressMobile(e.target.value)} />
                        <Form.Control.Feedback type="invalid">
                            موبایل را وارد کنید.
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="col-md-6 col-lg-6 col-sm-12">
                        <Form.Label>شماره همراه دوم <span className='text-[red]'> * </span></Form.Label>
                        <Form.Control required type="number" value={addressPhone} onChange={(e) => setAddressPhone(e.target.value)} />
                        <Form.Control.Feedback type="invalid">
                            شماره همراه دوم را وارد کنید.
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="col-md-6 col-lg-6 col-sm-12">
                        <Form.Label>استان <span className='text-[red]'> * </span></Form.Label>
                        <Dropdown value={provinceAddress} onChange={(e) => getCityById(e.value)} options={provinces} optionLabel="CName"
                            className="w-100 " />
                    </Form.Group>
                    <Form.Group className="col-md-6 col-lg-6 col-sm-12">
                        <Form.Label>شهر <span className='text-[red]'> * </span></Form.Label>
                        <Dropdown value={cityAddress} onChange={(e) => setCityAddress(e.value)} options={cityAddressList} optionLabel="CName"
                            className="w-100 " />          </Form.Group>
                    <Form.Group className="col-md-6 col-lg-6 col-sm-12">
                        <Form.Label>کدپستی <span className='text-[red]'> * </span></Form.Label>
                        <Form.Control required type="number" value={postalCodeAddress} onChange={(e) => setPostalCodeAddress(e.target.value)} />
                        <Form.Control.Feedback type="invalid">
                            کدپستی را وارد کنید.
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="col-md-12 col-lg-12 col-sm-12">
                        <Form.Label>آدرس <span className='text-[red]'> * </span></Form.Label>
                        <Form.Control required type="text" as="textarea" rows={3} value={addressFeildText} onChange={(e) => setAddressFeildText(e.target.value)} />
                        <Form.Control.Feedback type="invalid">
                            آدرس را وارد کنید.
                        </Form.Control.Feedback>
                    </Form.Group>



                    <div className='text-start d-flex justify-content-end w-100'>
                        <button type='submit' disabled={addressLoader} className='btn btn-primary d-flex align-items-center justify-content-center gap-2' style={{ width: 'auto' }}>
                            {addressLoader && <Loadr />}ثبت آدرس
                        </button>
                    </div>
                </Form>
            </Dialog>

            <Dialog draggable={false} header="موقعیت مکانی" className="custom-dialog dialog-profile" visible={visible} maximizable onHide={() => setVisible(false)}>
                <h6 className='my-2 mb-4'>لطفا موقعیت مکانی خود را مشخص کنید.</h6>
                <MapComponent
                    lat={lat}
                    lng={lng}
                    onSelect={handleAddressSelect}
                />
                <button type='button' className='btn w-100 btn-primary mt-4 ' onClick={() => setVisible(false)}>
                    ثبت
                </button>
            </Dialog>

        </>
    );
}

export default Profile;
